import clsx from 'clsx';

export interface SpinnerProps {
  size?: number;
  className?: string;
  thickness?: number;
}

export function Spinner({ size = 24, className, thickness = 2 }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="Loading"
      className={clsx('inline-block rounded-circle border-solid border-current border-t-transparent animate-spin', className)}
      style={{ width: size, height: size, borderWidth: thickness }}
    />
  );
}
